import request from '@/utils/request'
import { getShopId } from '@/api/shop/shopApi'

/**
 * 获取广告视频数据
 * @param {Object} params 请求参数
 * @returns {Promise} 返回Promise对象
 */
export function getAdvertVedioData(params) {
  return new Promise((resolve, reject) => {
    request({
      url: '/advertVedioView/list',
      method: 'get',
      params: {
        ...params,
        shopId: getShopId()
      }
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}